import { router, usePage } from "@inertiajs/vue3";
import useToastManager from "@/composables/toastManager";
import { useFlashStore } from "@/stores/flash";
import NProgress from "nprogress";

interface FlashMessage {
  [key: string]: string;
}

const PROGRESS_SCALE = 0.9;
const PROGRESS_START_DELAY = 250;
const PROGRESS_DONE_DELAY = 1000;

const page = usePage<any>();
const toastManager = useToastManager();
let progressTimeout: any | null = null;

function handleFlashMessages() {
  const flashStore = useFlashStore() as any;

  if (page.props.flash) {
    flashStore.setFlashMessages(page.props.flash);
  }

  const messages = flashStore.flashMessages;
  if (messages.length === 0) return;

  messages.forEach((message: any) => {
    Object.entries(message).forEach(([type, content]: any) => {
      toastManager.push(type, content);
    });
  });

  toastManager.trigger();
  flashStore.clearFlashMessages();
}

function handleProgress(visit: any) {
  if (!NProgress.isStarted()) {
    setTimeout(() => {
      if (NProgress.isStarted()) {
        NProgress.done();
      }
    }, PROGRESS_DONE_DELAY);
    return;
  }

  if (visit.completed) {
    NProgress.done();
  } else if (visit.interrupted) {
    NProgress.set(0);
  } else if (visit.cancelled) {
    NProgress.done();
    NProgress.remove();
  }
}

router.on("progress", (event) => {
  const { percentage } = event.detail.progress as { percentage: number };

  if (percentage) {
    NProgress.set((percentage / 100) * PROGRESS_SCALE);
  }
});

router.on("start", () => {
  progressTimeout = window.setTimeout(() => NProgress.start(), PROGRESS_START_DELAY);
});

router.on("navigate", () => {
  handleFlashMessages();
});

router.on("prefetched", () => {
  NProgress.done();
});

router.on("finish", (event) => {
  if (progressTimeout) {
    window.clearTimeout(progressTimeout);
    progressTimeout = null;
  }

  handleProgress(event.detail.visit);
  handleFlashMessages();
});
